export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    console.warn('========================');
    console.error('Ошибка Vue: STACK', err.stack); // Вывод полного стектрейса
    console.error('Ошибка Vue: ERROR', err); // Вывод ошибки
    console.log('Информация:', info); // Дополнительный контекст
    console.log('Компонент:', instance); // Компонент, в котором произошла ошибка
    console.warn('========================'); // Информация о компоненте
  };
});